import { SVGProps } from 'react'
const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#4F4848"
      d="M12.203.688h-8c-2.4 0-4 1.2-4 4v5.6c0 2.8 1.6 4 4 4h8c2.4 0 4-1.2 4-4v-5.6c0-2.8-1.6-4-4-4Zm.376 4.872-2.504 2c-.528.424-1.2.632-1.872.632-.672 0-1.352-.208-1.872-.632l-2.504-2a.615.615 0 0 1-.096-.848.598.598 0 0 1 .84-.096l2.504 2c.608.488 1.64.488 2.248 0l2.504-2a.59.59 0 0 1 .84.096.607.607 0 0 1-.088.848Z"
      opacity={0.6}
    />
  </svg>
)
export default EmailIcon
